import React from "react"
import ParticipantSidebar from "../../components/sidebars/ParticipantSidebar"

import styles from "../../styles/Page-with-Sidebar.module.css"

export default function Discharge() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.sidebar}>
        <ParticipantSidebar />
      </div>
      <div className={styles.content}>
        <h1>Discharge</h1>
      </div>
    </div>
  )
}
